import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file 下拉树
 * @author alfielv
 */
import _ from 'lodash';
import classnames from 'classnames';
import React, { useCallback, useMemo } from 'react';
import { SelectTree } from '@tencent/spaui';
import { PREFIX_CLS } from '../../../../constants';
var prefixCls = "".concat(PREFIX_CLS, "-listview");
export default (function (props) {
  var valueFromProps = props.value,
      config = props.config,
      onChange = props.onChange,
      setActive = props.setActive;

  var _ref = config || {},
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      multiple = _ref.multiple,
      _ref$SelectProps = _ref.SelectProps,
      SelectProps = _ref$SelectProps === void 0 ? {} : _ref$SelectProps,
      onChangeFromConfig = _ref.onChange,
      onOpenFromConfig = _ref.onOpen; // 提前处理value兼容spaui组件多选类型


  var value = useMemo(function () {
    if (multiple) {
      return _.isArray(valueFromProps) ? valueFromProps : [];
    }

    return valueFromProps;
  }, [valueFromProps, multiple]);
  var handleChange = useCallback(function (event, value, currentNode, valueMap) {
    onChangeFromConfig === null || onChangeFromConfig === void 0 ? void 0 : onChangeFromConfig(event, value, currentNode, valueMap);
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
  }, [onChange, onChangeFromConfig]);
  var handleOpen = useCallback(function (event, open) {
    onOpenFromConfig === null || onOpenFromConfig === void 0 ? void 0 : onOpenFromConfig(event, open);
    setActive === null || setActive === void 0 ? void 0 : setActive(open);
  }, [setActive, onOpenFromConfig]);
  return /*#__PURE__*/React.createElement(SelectTree, _extends({
    placeholder: "\u8BF7\u9009\u62E9\u7B5B\u9009\u6761\u4EF6",
    mountTarget: "body"
  }, config, {
    className: classnames("".concat(prefixCls, "__selecttree"), className),
    SelectProps: _objectSpread(_objectSpread({
      onOpen: handleOpen
    }, SelectProps), {}, {
      className: classnames("".concat(prefixCls, "__select"), SelectProps.className),
      dropClassName: classnames("".concat(prefixCls, "__selecttree"), SelectProps.dropClassName)
    }),
    value: value,
    onChange: handleChange
  }));
});